import ElementContent from '@/components/sections/builder/elements/body/product-detail/content';
import ElementSetting from '@/components/sections/builder/elements/body/product-detail/setting';
import ProductDetailTitle from '@/components/sections/builder/elements/body/product-detail/title';
import ProductDetailDescription from '@/components/sections/builder/elements/body/product-detail/description';
import ProductDetailPrice from '@/components/sections/builder/elements/body/product-detail/price';
import { ElementDataType } from '@/components/sections/builder/elements/body/product-detail/type';
import { Type } from 'lucide-react';
import ProductDetailVariantPicker from '@/components/sections/builder/elements/body/product-detail/variant-picker';
import ProductDetailQuantity from '@/components/sections/builder/elements/body/product-detail/quantity';
import ProductDetailButton from '@/components/sections/builder/elements/body/product-detail/button';

const defaultData: ElementDataType = {
  name: 'Product Detail',
  colorBackgroundScheme: 'background1',
  isShowSecondaryBackground: false,
  topPadding: 36,
  bottomPadding: 36,
  isShowCurrencyCodes: true,
  saleBadgeColorScheme: 'background1',
  soldOutBadgeColorScheme: 'background1',
  topImage: 0,
  galleryPosition: 'horizontal',
};

export const ElementPreviewIcon = Type;

const ProductDetail = {
  type: 'product_detail',
  group: 'body_product_detail',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [
    ProductDetailTitle,
    ProductDetailPrice,
    ProductDetailVariantPicker,
    ProductDetailQuantity,
    ProductDetailButton,
    ProductDetailDescription,
  ],
  childs: [
    ProductDetailTitle,
    ProductDetailPrice,
    ProductDetailVariantPicker,
    ProductDetailQuantity,
    ProductDetailButton,
    ProductDetailDescription,
  ],
  isImmutable: true,
};

export default ProductDetail;
